import script from "./instanceList.vue?vue&type=script&lang=js"
export * from "./instanceList.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__